module.exports = __webpack_public_path__ + "static/media/SyrianOrg.233ab17e.png";